/**
 * Online Shop Manage : 网店管理
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/schl/v1/{organizationId}/online/shop',
  items: [
    /**
     * 查询列表
     */
    { key: 'getOnlineShopPage', url: '/page', method: 'POST' },
    /**
     * 网店设置
     */
    { key: 'setOnlineShop', url: '/setting', method: 'POST' },

    /**
     * 查询网店设置
     */
    { key: 'getOnlineShopSetting', url: '/get/setting', method: 'GET' },

    /**
     * 新增与修改
     */
    { key: 'saveOnlineShop', url: '/save', method: 'POST' },

    /**
     * 新增店铺时的店铺校验
     */
     { key: 'checkShopConfig', url: '/check-shop-config', method: 'POST' },
    /**
     * 禁用 OR 启用
     */
    { key: 'operationOnlineShop', url: '/operation', method: 'POST', type: 'query' },
    // 更新店铺状态
    { key: 'updateShopStatus', url: '/updateShopStatus', method: 'POST' },
    /**
     * 查询详情
     */
    { key: 'getOnlineShopDetails', url: '/details', method: 'GET' },
    /**
     * 查询网店列表（远程调用）
     */
     { key: 'getOnlineShopByCode', url: '/details/by/codes', method: 'POST' },
    /**
     * 删除数据
     */
    { key: 'deleteOnlineShop', url: '/delete', method: 'POST', type: 'query' },
    /**
     * 批量删除数据
     */
    { key: 'batchDeleteOnlineShop', url: '/deletes', method: 'POST' },
    /**
     * 拼多多授权
     */
    { key: 'authorizeOnlineShop', url: '/authorize', method: 'GET' },
  ],
};

export default {
  ...generate(config),
};
